module.exports = __webpack_public_path__ + "static/media/img2.f71a6ee2.jpg";